import SEO from "../components/common/SEO";

const Privacy = () => {
  return (
    <>
      <SEO
        title="Privacy Policy | AZ Construction"
        description="Read AZ Construction's privacy policy to understand how we collect, use, and protect your personal information."
        url="https://azconstruction.com/privacy-policy"
      />
      {/* Banner */}

      <section 
        className="relative pt-32 md:pt-40 pb-16 md:pb-28 overflow-hidden"
        style={{
          backgroundImage: "linear-gradient(rgba(8,43,87,.92), rgba(8,43,87,.92)), url('/images/legal-banner.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="container-custom text-center relative z-10">

          <h1 className="text-4xl md:text-5xl lg:text-7xl font-bold text-white">
            Privacy Policy
          </h1>

          <p className="text-white/80 mt-6 max-w-3xl mx-auto">
            Your privacy is important to us. This Privacy Policy
            explains how AZ Construction collects, uses and protects
            your information when you visit our website or use our services.
          </p>

        </div>
      </section>

      {/* Content */}

      <section className="py-24 bg-white">
        <div className="container-custom">

          <div className="max-w-5xl mx-auto bg-white">

            <p className="text-gray-600 mb-10">
              Last Updated: June 2026
            </p>

            {/* Section */}

            <div className="mb-12">
              <h2 className="text-3xl font-bold text-[#082B57] mb-5">
                1. Information We Collect
              </h2>

              <p className="text-gray-600 leading-8">
                We may collect personal information such as your
                name, email address, phone number, project details,
                and any information you voluntarily provide through
                contact forms, consultation requests or inquiries.
              </p>
            </div>

            {/* Section */}

            <div className="mb-12">
              <h2 className="text-3xl font-bold text-[#082B57] mb-5">
                2. How We Use Your Information
              </h2>

              <ul className="list-disc pl-6 text-gray-600 space-y-3">
                <li>Respond to inquiries and service requests.</li>
                <li>Provide construction and consultancy services.</li>
                <li>Improve our website and user experience.</li>
                <li>Send project updates and communications.</li>
                <li>Maintain business records and compliance.</li>
              </ul>
            </div>

            {/* Section */}

            <div className="mb-12">
              <h2 className="text-3xl font-bold text-[#082B57] mb-5">
                3. Cookies & Tracking Technologies
              </h2>

              <p className="text-gray-600 leading-8">
                Our website may use cookies and analytics tools to
                improve functionality, understand visitor behavior
                and enhance website performance.
              </p>
            </div>

            {/* Section */}

            <div className="mb-12">
              <h2 className="text-3xl font-bold text-[#082B57] mb-5">
                4. Data Protection
              </h2>

              <p className="text-gray-600 leading-8">
                We implement appropriate security measures to protect
                personal information against unauthorized access,
                disclosure, alteration or destruction.
              </p>
            </div>

            {/* Section */}

            <div className="mb-12">
              <h2 className="text-3xl font-bold text-[#082B57] mb-5">
                5. Third-Party Services
              </h2>

              <p className="text-gray-600 leading-8">
                We may use trusted third-party tools and services
                such as analytics platforms, communication tools and
                hosting providers. These services operate under their
                own privacy policies.
              </p>
            </div>

            {/* Section */}

            <div className="mb-12">
              <h2 className="text-3xl font-bold text-[#082B57] mb-5">
                6. Information Sharing
              </h2>

              <p className="text-gray-600 leading-8">
                We do not sell, trade or rent your personal information
                to third parties. Information may only be shared when
                required by law or to provide requested services.
              </p>
            </div>

            {/* Section */}

            <div className="mb-12">
              <h2 className="text-3xl font-bold text-[#082B57] mb-5">
                7. Your Rights
              </h2>

              <p className="text-gray-600 leading-8">
                You may request access, correction or deletion of your
                personal information by contacting us directly.
              </p>
            </div>

            {/* Section */}

            <div className="mb-12">
              <h2 className="text-3xl font-bold text-[#082B57] mb-5">
                8. Changes To This Policy
              </h2>

              <p className="text-gray-600 leading-8">
                We reserve the right to update this Privacy Policy at
                any time. Changes will be posted on this page with an
                updated revision date.
              </p>
            </div>

            {/* Section */}

            <div>
              <h2 className="text-3xl font-bold text-[#082B57] mb-5">
                9. Contact Us
              </h2>

              <p className="text-gray-600 leading-8">
                If you have any questions regarding this Privacy Policy,
                please contact us:
              </p>

              <div className="mt-6 bg-slate-50 rounded-2xl p-6">
                <p><strong>AZ Construction</strong></p>
                <p>Email: contact@azconstruction.com</p>
                <p>Phone: +91 99266 66609, +91 83195 69994</p>
                <p>Address: Indore, Madhya Pradesh, India</p>
              </div>
            </div>

          </div>

        </div>
      </section>
    </>
  );
};

export default Privacy;